module.exports = __webpack_public_path__ + "img/bird-11-left.ac9cf2c3.png";